'use client';

import { ReactNode, useEffect } from 'react';

const PrintEffect = ({ children }: { children?: ReactNode }) => {
  useEffect(() => {
    window.print();
  }, []);

  return children;
};

export default PrintEffect;
